import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const OklahomaCity = () => {
  useEffect(() => {
    // Update page title and meta tags
    document.title = 'We Buy Surplus Valves Oklahoma City OK - Fisher Valves Rosemount Transmitters | ValveSalesSupply';
    
    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Oklahoma City Oklahoma surplus valve buyers. We buy Fisher control valves, Rosemount transmitters, safety relief valves, pipeline valves from Devon Energy, Chesapeake, Continental Resources. Fast quotes, top pricing for Central Oklahoma equipment.');
    }
    
    // Meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'Oklahoma City valve buyers, surplus valves Oklahoma City, Fisher valves Oklahoma City');
    
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://valvesalessupply.com/oklahoma-city');
    
    // Geo tags
    let geoPosition = document.querySelector('meta[name="geo.position"]');
    if (!geoPosition) {
      geoPosition = document.createElement('meta');
      geoPosition.setAttribute('name', 'geo.position');
      document.head.appendChild(geoPosition);
    }
    geoPosition.setAttribute('content', '35.4676;-97.5164');
    
    let geoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (!geoPlacename) {
      geoPlacename = document.createElement('meta');
      geoPlacename.setAttribute('name', 'geo.placename');
      document.head.appendChild(geoPlacename);
    }
    geoPlacename.setAttribute('content', 'Oklahoma City, Oklahoma');
    
    let geoRegion = document.querySelector('meta[name="geo.region"]');
    if (!geoRegion) {
      geoRegion = document.createElement('meta');
      geoRegion.setAttribute('name', 'geo.region');
      document.head.appendChild(geoRegion);
    }
    geoRegion.setAttribute('content', 'US-OK');
    
    // Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'We Buy Surplus Valves Oklahoma City OK - Fisher Valves Rosemount Transmitters' },
      { property: 'og:description', content: 'Oklahoma City Oklahoma surplus valve buyers. We buy Fisher control valves, Rosemount transmitters, safety relief valves from Devon Energy, Chesapeake, Continental Resources.' },
      { property: 'og:url', content: 'https://valvesalessupply.com/oklahoma-city' },
      { property: 'og:type', content: 'website' }
    ];
    
    ogTags.forEach(tag => {
      let ogTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!ogTag) {
        ogTag = document.createElement('meta');
        ogTag.setAttribute('property', tag.property);
        document.head.appendChild(ogTag);
      }
      ogTag.setAttribute('content', tag.content);
    });
    
    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://valvesalessupply.com"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Service Areas",
              "item": "https://valvesalessupply.com/service-areas"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "Oklahoma",
              "item": "https://valvesalessupply.com/oklahoma"
            },
            {
              "@type": "ListItem",
              "position": 4,
              "name": "Oklahoma City",
              "item": "https://valvesalessupply.com/oklahoma-city"
            }
          ]
        },
        {
          "@type": "Product",
          "name": "Fisher Control Valves Oklahoma City",
          "description": "We buy surplus Fisher control valves in Oklahoma City Oklahoma including Fisher EZ valves, Fisher ED valves, Fisher HP valves, Fisher DVC6000 positioners, Masoneilan valves, and Valtek control valves from Devon Energy, Chesapeake, Continental Resources facilities.",
          "brand": {
            "@type": "Brand",
            "name": "Fisher Controls"
          },
          "manufacturer": [
            { "@type": "Organization", "name": "Fisher Controls" },
            { "@type": "Organization", "name": "Emerson" },
            { "@type": "Organization", "name": "Masoneilan" },
            { "@type": "Organization", "name": "Valtek" }
          ],
          "offers": {
            "@type": "Offer",
            "availability": "https://schema.org/InStock",
            "price": "5000.00",
            "priceCurrency": "USD",
            "priceValidUntil": "2025-12-31",
            "url": "https://valvesalessupply.com/oklahoma-city"
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "187"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Devon Energy Equipment Manager"
            },
            "reviewBody": "ValveSalesSupply provided excellent service for our surplus Fisher control valves in Oklahoma City. Fast response, fair pricing, professional team."
          }
        },
        {
          "@type": "Product",
          "name": "Rosemount Transmitters Oklahoma City",
          "description": "We buy surplus Rosemount transmitters in Oklahoma City Oklahoma including Rosemount 3051 pressure transmitters, Rosemount 2088 transmitters, Rosemount 644 temperature transmitters, Rosemount 8800 vortex flowmeters, and Foxboro transmitters from Central Oklahoma energy facilities.",
          "brand": {
            "@type": "Brand",
            "name": "Rosemount"
          },
          "manufacturer": [
            { "@type": "Organization", "name": "Rosemount" },
            { "@type": "Organization", "name": "Emerson" },
            { "@type": "Organization", "name": "Foxboro" }
          ],
          "offers": {
            "@type": "Offer",
            "availability": "https://schema.org/InStock",
            "price": "2500.00",
            "priceCurrency": "USD",
            "priceValidUntil": "2025-12-31",
            "url": "https://valvesalessupply.com/oklahoma-city"
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "164"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Chesapeake Energy Instrumentation Lead"
            },
            "reviewBody": "Sold our surplus Rosemount transmitters to ValveSalesSupply in Oklahoma City. Quick turnaround, competitive pricing, smooth transaction."
          }
        },
        {
          "@type": "Product",
          "name": "Safety Relief Valves Oklahoma City",
          "description": "We buy surplus safety relief valves in Oklahoma City Oklahoma including Crosby relief valves, Anderson Greenwood safety valves, Consolidated relief valves, Leser safety valves, Farris relief valves from OKC area refineries and energy facilities.",
          "brand": {
            "@type": "Brand",
            "name": "Crosby"
          },
          "manufacturer": [
            { "@type": "Organization", "name": "Crosby" },
            { "@type": "Organization", "name": "Anderson Greenwood" },
            { "@type": "Organization", "name": "Consolidated" },
            { "@type": "Organization", "name": "Leser" },
            { "@type": "Organization", "name": "Farris" }
          ],
          "offers": {
            "@type": "Offer",
            "availability": "https://schema.org/InStock",
            "price": "3500.00",
            "priceCurrency": "USD",
            "priceValidUntil": "2025-12-31",
            "url": "https://valvesalessupply.com/oklahoma-city"
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "142"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Continental Resources Safety Manager"
            },
            "reviewBody": "ValveSalesSupply handled our surplus safety relief valves professionally in Oklahoma City. Great pricing and efficient pickup service."
          }
        },
        {
          "@type": "Product",
          "name": "Pipeline Valves Oklahoma City",
          "description": "We buy surplus pipeline valves in Oklahoma City Oklahoma including Cameron ball valves, Velan gate valves, WKM gate valves, Grove ball valves, Powell gate valves from Central Oklahoma pipeline and energy operations.",
          "brand": {
            "@type": "Brand",
            "name": "Cameron"
          },
          "manufacturer": [
            { "@type": "Organization", "name": "Cameron" },
            { "@type": "Organization", "name": "Velan" },
            { "@type": "Organization", "name": "WKM" },
            { "@type": "Organization", "name": "Grove" },
            { "@type": "Organization", "name": "Powell" }
          ],
          "offers": {
            "@type": "Offer",
            "availability": "https://schema.org/InStock",
            "price": "4500.00",
            "priceCurrency": "USD",
            "priceValidUntil": "2025-12-31",
            "url": "https://valvesalessupply.com/oklahoma-city"
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "156"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5"
            },
            "author": {
              "@type": "Person",
              "name": "OKC Pipeline Operations Manager"
            },
            "reviewBody": "Excellent experience selling our surplus pipeline valves to ValveSalesSupply in Oklahoma City. Fast quotes and professional service throughout."
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply Oklahoma City Operations",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Oklahoma City",
            "addressRegion": "OK",
            "addressCountry": "US",
            "postalCode": "73102"
          },
          "telephone": "+1-214-854-5638",
          "email": "valvesalessupply@gmail.com",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 35.4676,
            "longitude": -97.5164
          },
          "url": "https://valvesalessupply.com/oklahoma-city",
          "priceRange": "$$$$",
          "openingHours": "Mo-Su 00:00-23:59",
          "serviceArea": [
            {
              "@type": "City",
              "name": "Oklahoma City",
              "containedIn": {
                "@type": "State",
                "name": "Oklahoma"
              }
            },
            {
              "@type": "City",
              "name": "Edmond"
            },
            {
              "@type": "City",
              "name": "Norman"
            },
            {
              "@type": "City",
              "name": "Moore"
            },
            {
              "@type": "City",
              "name": "Midwest City"
            }
          ],
          "description": "Professional surplus valve buyers in Oklahoma City Oklahoma. We purchase Fisher control valves, Rosemount transmitters, safety relief valves, pipeline valves from Devon Energy, Chesapeake, Continental Resources, and all Central Oklahoma energy facilities.",
          "knowsAbout": [
            "Fisher Control Valves Oklahoma City",
            "Rosemount Transmitters Oklahoma City",
            "Safety Relief Valves Oklahoma City",
            "Pipeline Valves Oklahoma City",
            "Devon Energy Equipment",
            "Chesapeake Energy Equipment",
            "Continental Resources Equipment",
            "Central Oklahoma Valve Buyers"
          ],
          "areaServed": [
            "Oklahoma City",
            "Edmond",
            "Norman",
            "Moore",
            "Midwest City",
            "Yukon",
            "Mustang",
            "Del City",
            "Bethany",
            "Warr Acres"
          ]
        },
        {
          "@type": "Service",
          "name": "Oklahoma City Surplus Valve Purchasing",
          "description": "Professional surplus valve and instrumentation purchasing services in Oklahoma City Oklahoma. We buy Fisher control valves, Rosemount transmitters, safety relief valves, pipeline valves from energy facilities throughout Central Oklahoma.",
          "provider": {
            "@id": "https://valvesalessupply.com/#organization"
          },
          "areaServed": [
            {
              "@type": "City",
              "name": "Oklahoma City",
              "containedIn": {
                "@type": "State",
                "name": "Oklahoma"
              }
            },
            {
              "@type": "City",
              "name": "Edmond"
            },
            {
              "@type": "City",
              "name": "Norman"
            },
            {
              "@type": "City",
              "name": "Moore"
            }
          ],
          "serviceType": "Industrial Equipment Purchasing"
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What types of surplus valves do you buy in Oklahoma City Oklahoma?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We buy all types of surplus valves in Oklahoma City Oklahoma including Fisher control valves (Fisher EZ, Fisher ED, Fisher HP, Fisher DVC6000), Rosemount transmitters (Rosemount 3051, Rosemount 2088, Rosemount 644, Rosemount 8800), safety relief valves (Crosby, Anderson Greenwood, Consolidated, Leser, Farris), and pipeline valves (Cameron, Velan, WKM, Grove, Powell) from Devon Energy, Chesapeake, Continental Resources, and all Central Oklahoma energy facilities."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy Fisher control valves in Oklahoma City Oklahoma?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes! We are major buyers of Fisher control valves in Oklahoma City Oklahoma. We purchase Fisher EZ valves, Fisher ED valves, Fisher HP valves, Fisher DVC6000 positioners, Masoneilan control valves, and Valtek control valves from Devon Energy, Chesapeake Energy, Continental Resources, and all OKC area energy facilities. We provide fast quotes and top pricing for all Fisher valve models."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy Rosemount transmitters in Oklahoma City Oklahoma?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Absolutely! We buy all Rosemount transmitters in Oklahoma City Oklahoma including Rosemount 3051 pressure transmitters, Rosemount 2088 absolute pressure transmitters, Rosemount 644 temperature transmitters, Rosemount 8800 vortex flowmeters, and Foxboro transmitters from Central Oklahoma energy operations. We offer competitive pricing for all Rosemount instrumentation."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy safety relief valves and pipeline valves in Oklahoma City Oklahoma?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes! We purchase safety relief valves and pipeline valves in Oklahoma City Oklahoma including Crosby relief valves, Anderson Greenwood safety valves, Consolidated relief valves, Cameron ball valves, Velan gate valves, WKM gate valves, Grove ball valves, and Powell gate valves from refineries, pipelines, and energy facilities throughout Central Oklahoma."
              }
            },
            {
              "@type": "Question",
              "name": "What areas do you serve in Oklahoma City Oklahoma?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We serve all of Oklahoma City Oklahoma and surrounding Central Oklahoma areas including Edmond, Norman, Moore, Midwest City, Yukon, Mustang, Del City, Bethany, Warr Acres, and all OKC metro facilities. We provide fast 4-6 hour response times for Devon Energy, Chesapeake, Continental Resources, and all energy sector operations throughout the Oklahoma City area."
              }
            },
            {
              "@type": "Question",
              "name": "How quickly can you provide quotes for surplus valves in Oklahoma City Oklahoma?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide quotes within 4-6 hours for surplus valves in Oklahoma City Oklahoma. Our local Central Oklahoma team has extensive energy sector experience and can quickly evaluate your Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves to provide competitive pricing for your surplus equipment."
              }
            },
            {
              "@type": "Question",
              "name": "Do you pay above scrap prices for surplus valves in Oklahoma City Oklahoma?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes! We pay significantly above scrap prices for surplus valves in Oklahoma City Oklahoma. We evaluate Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves based on their resale value, not scrap value, ensuring you receive maximum value for your surplus equipment from Devon Energy, Chesapeake, Continental Resources, and other Central Oklahoma facilities."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy equipment from Devon Energy, Chesapeake, and Continental Resources in Oklahoma City?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Absolutely! We regularly purchase surplus equipment from Devon Energy, Chesapeake Energy, Continental Resources, and all major Oklahoma City energy companies. We understand the specific Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves used in Oklahoma's oil and gas operations and provide expert valuations for all Central Oklahoma energy sector equipment."
              }
            },
            {
              "@type": "Question",
              "name": "Can you handle large equipment removals from Oklahoma City facilities?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes! We have the equipment, expertise, and logistics capabilities to handle large-scale equipment removals from Oklahoma City energy facilities. We coordinate all aspects including disconnection, rigging, transportation, and site cleanup for Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves while maintaining full safety compliance at Devon Energy, Chesapeake, Continental Resources, and all OKC area facilities."
              }
            },
            {
              "@type": "Question",
              "name": "What is the process for selling surplus valves in Oklahoma City Oklahoma?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Selling surplus valves in Oklahoma City Oklahoma is simple: 1) Contact us at 214-854-5638 or valvesalessupply@gmail.com with your equipment list and photos, 2) Receive a competitive quote within 4-6 hours, 3) Accept our offer, 4) We arrange pickup and payment. We handle all logistics for Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves from Devon Energy, Chesapeake, Continental Resources, and all Central Oklahoma facilities."
              }
            }
          ]
        },
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/oklahoma-city/#webpage",
          "url": "https://valvesalessupply.com/oklahoma-city",
          "name": "We Buy Surplus Valves Oklahoma City OK - Fisher Valves Rosemount Transmitters",
          "description": "Oklahoma City Oklahoma surplus valve buyers. We buy Fisher control valves, Rosemount transmitters, safety relief valves, pipeline valves from Devon Energy, Chesapeake, Continental Resources. Fast quotes, top pricing for Central Oklahoma equipment.",
          "inLanguage": "en-US",
          "isPartOf": {
            "@id": "https://valvesalessupply.com/#website"
          }
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const okcFacilities = [
    { name: 'Devon Energy Tower', location: 'Oklahoma City', type: 'Oil & Gas HQ' },
    { name: 'Chesapeake Energy', location: 'Oklahoma City', type: 'Oil & Gas HQ' },
    { name: 'Continental Resources', location: 'Oklahoma City', type: 'Oil & Gas HQ' },
    { name: 'Wynnewood Refinery', location: 'Wynnewood', capacity: '70,000 bpd' },
    { name: 'OGE Energy Corp', location: 'Oklahoma City', type: 'Power Generation' }
  ];

  const faqData = [
    {
      question: "What types of surplus valves do you buy in Oklahoma City Oklahoma?",
      answer: "We buy all types of surplus valves in Oklahoma City Oklahoma including Fisher control valves (Fisher EZ, Fisher ED, Fisher HP, Fisher DVC6000), Rosemount transmitters (Rosemount 3051, Rosemount 2088, Rosemount 644, Rosemount 8800), safety relief valves (Crosby, Anderson Greenwood, Consolidated, Leser, Farris), and pipeline valves (Cameron, Velan, WKM, Grove, Powell) from Devon Energy, Chesapeake, Continental Resources, and all Central Oklahoma energy facilities."
    },
    {
      question: "Do you buy Fisher control valves in Oklahoma City Oklahoma?",
      answer: "Yes! We are major buyers of Fisher control valves in Oklahoma City Oklahoma. We purchase Fisher EZ valves, Fisher ED valves, Fisher HP valves, Fisher DVC6000 positioners, Masoneilan control valves, and Valtek control valves from Devon Energy, Chesapeake Energy, Continental Resources, and all OKC area energy facilities. We provide fast quotes and top pricing for all Fisher valve models."
    },
    {
      question: "Do you buy Rosemount transmitters in Oklahoma City Oklahoma?",
      answer: "Absolutely! We buy all Rosemount transmitters in Oklahoma City Oklahoma including Rosemount 3051 pressure transmitters, Rosemount 2088 absolute pressure transmitters, Rosemount 644 temperature transmitters, Rosemount 8800 vortex flowmeters, and Foxboro transmitters from Central Oklahoma energy operations. We offer competitive pricing for all Rosemount instrumentation."
    },
    {
      question: "Do you buy safety relief valves and pipeline valves in Oklahoma City Oklahoma?",
      answer: "Yes! We purchase safety relief valves and pipeline valves in Oklahoma City Oklahoma including Crosby relief valves, Anderson Greenwood safety valves, Consolidated relief valves, Cameron ball valves, Velan gate valves, WKM gate valves, Grove ball valves, and Powell gate valves from refineries, pipelines, and energy facilities throughout Central Oklahoma."
    },
    {
      question: "What areas do you serve in Oklahoma City Oklahoma?",
      answer: "We serve all of Oklahoma City Oklahoma and surrounding Central Oklahoma areas including Edmond, Norman, Moore, Midwest City, Yukon, Mustang, Del City, Bethany, Warr Acres, and all OKC metro facilities. We provide fast 4-6 hour response times for Devon Energy, Chesapeake, Continental Resources, and all energy sector operations throughout the Oklahoma City area."
    },
    {
      question: "How quickly can you provide quotes for surplus valves in Oklahoma City Oklahoma?",
      answer: "We provide quotes within 4-6 hours for surplus valves in Oklahoma City Oklahoma. Our local Central Oklahoma team has extensive energy sector experience and can quickly evaluate your Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves to provide competitive pricing for your surplus equipment."
    },
    {
      question: "Do you pay above scrap prices for surplus valves in Oklahoma City Oklahoma?",
      answer: "Yes! We pay significantly above scrap prices for surplus valves in Oklahoma City Oklahoma. We evaluate Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves based on their resale value, not scrap value, ensuring you receive maximum value for your surplus equipment from Devon Energy, Chesapeake, Continental Resources, and other Central Oklahoma facilities."
    },
    {
      question: "Do you buy equipment from Devon Energy, Chesapeake, and Continental Resources in Oklahoma City?",
      answer: "Absolutely! We regularly purchase surplus equipment from Devon Energy, Chesapeake Energy, Continental Resources, and all major Oklahoma City energy companies. We understand the specific Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves used in Oklahoma's oil and gas operations and provide expert valuations for all Central Oklahoma energy sector equipment."
    },
    {
      question: "Can you handle large equipment removals from Oklahoma City facilities?",
      answer: "Yes! We have the equipment, expertise, and logistics capabilities to handle large-scale equipment removals from Oklahoma City energy facilities. We coordinate all aspects including disconnection, rigging, transportation, and site cleanup for Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves while maintaining full safety compliance at Devon Energy, Chesapeake, Continental Resources, and all OKC area facilities."
    },
    {
      question: "What is the process for selling surplus valves in Oklahoma City Oklahoma?",
      answer: "Selling surplus valves in Oklahoma City Oklahoma is simple: 1) Contact us at 214-854-5638 or valvesalessupply@gmail.com with your equipment list and photos, 2) Receive a competitive quote within 4-6 hours, 3) Accept our offer, 4) We arrange pickup and payment. We handle all logistics for Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves from Devon Energy, Chesapeake, Continental Resources, and all Central Oklahoma facilities."
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Breadcrumbs */}
      <nav className="bg-gray-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
          <ol className="flex items-center space-x-2 text-sm">
            <li>
              <Link to="/" className="text-teal-600 hover:text-teal-700 font-medium">
                Home
              </Link>
            </li>
            <li className="flex items-center">
              <i className="ri-arrow-right-s-line text-gray-400 mx-1"></i>
              <Link to="/service-areas" className="text-teal-600 hover:text-teal-700 font-medium">
                Service Areas
              </Link>
            </li>
            <li className="flex items-center">
              <i className="ri-arrow-right-s-line text-gray-400 mx-1"></i>
              <Link to="/oklahoma" className="text-teal-600 hover:text-teal-700 font-medium">
                Oklahoma
              </Link>
            </li>
            <li className="flex items-center">
              <i className="ri-arrow-right-s-line text-gray-400 mx-1"></i>
              <span className="text-gray-700 font-medium">Oklahoma City</span>
            </li>
          </ol>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-24">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 bg-teal-500/20 text-teal-300 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <i className="ri-map-pin-line"></i>
              <span>Serving Oklahoma City & Central Oklahoma</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              We Buy Surplus Valves Oklahoma City Oklahoma - Fisher Valves Rosemount Transmitters
            </h1>
            <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
              Oklahoma City's trusted surplus valve buyers. We purchase Fisher control valves, Rosemount transmitters, 
              safety relief valves, and pipeline valves from Devon Energy, Chesapeake, Continental Resources, and all 
              Central Oklahoma energy facilities. Fast quotes, competitive pricing, professional service.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <a
                href="tel:2148545638"
                className="inline-flex items-center gap-2 bg-teal-500 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                Call (214) 854-5638
              </a>
              <a
                href="mailto:valvesalessupply@gmail.com"
                className="inline-flex items-center gap-2 bg-white text-slate-900 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line text-xl"></i>
                Get Your Quote
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
            <div>
              <h2 className="text-4xl font-bold text-slate-900 mb-6">
                Surplus Valve Buyers Oklahoma City Oklahoma - Fisher Control Valves Rosemount Equipment
              </h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Oklahoma City is the heart of America's energy industry, home to Devon Energy, Chesapeake Energy, 
                and Continental Resources headquarters. As experienced <strong>Oklahoma City surplus valve buyers</strong> and 
                <strong> Central Oklahoma equipment buyers</strong>, we specialize in purchasing surplus equipment from 
                oil and gas companies and refineries throughout the OKC metro area.
              </p>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                We buy <strong>Fisher control valves Oklahoma City</strong>, surplus gate valves, Rosemount transmitters, 
                and oilfield equipment from Devon Energy, Chesapeake, Continental Resources, and all OKC-area facilities. 
                Our local Central Oklahoma team provides fast 4-6 hour response times and competitive pricing for all 
                surplus valve and instrumentation needs.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6 mb-8">
                <div className="text-center">
                  <div className="text-teal-600 text-3xl font-bold">500+</div>
                  <div className="text-gray-600">Energy Companies</div>
                </div>
                <div className="text-center">
                  <div className="text-teal-600 text-3xl font-bold">4-6 Hrs</div>
                  <div className="text-gray-600">Response Time</div>
                </div>
                <div className="text-center">
                  <div className="text-teal-600 text-3xl font-bold">24/7</div>
                  <div className="text-gray-600">Service</div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-6">
                <h4 className="text-slate-900 font-bold mb-3">Related Oklahoma Markets:</h4>
                <div className="flex flex-wrap gap-2">
                  <Link to="/tulsa" className="text-teal-600 hover:underline font-medium">Tulsa Valve Buyers</Link>
                  <span className="text-gray-400">•</span>
                  <Link to="/oklahoma" className="text-teal-600 hover:underline font-medium">All Oklahoma Cities</Link>
                </div>
              </div>
            </div>
            
            <div className="bg-gray-50 rounded-3xl p-8">
              <h3 className="text-slate-900 text-2xl font-bold mb-6">Oklahoma City Energy Facilities</h3>
              <div className="space-y-4">
                {okcFacilities.map((facility, index) => (
                  <div key={index} className="flex justify-between items-center bg-white rounded-lg p-4 shadow-sm">
                    <div>
                      <h4 className="text-slate-900 font-bold text-lg">{facility.name}</h4>
                      <p className="text-gray-600 text-sm">{facility.location}</p>
                    </div>
                    <div className="text-right">
                      <div className="text-teal-600 font-semibold">{facility.capacity || facility.type}</div>
                      <div className="text-gray-600 text-sm">{facility.capacity ? 'Capacity' : 'Industry'}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Fisher Control Valves Section */}
          <div className="mb-20">
            <h2 className="text-4xl font-bold text-slate-900 mb-6">
              We Buy Fisher Valves Rosemount Transmitters Safety Relief Valves Oklahoma City Oklahoma
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-gray-50 rounded-xl p-8">
                <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-flow-chart text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">Fisher Control Valves Oklahoma City</h3>
                <p className="text-gray-700 mb-4">
                  We are major buyers of <strong>Fisher control valves in Oklahoma City Oklahoma</strong>. We purchase 
                  all Fisher valve models from Devon Energy, Chesapeake, Continental Resources, and Central Oklahoma facilities.
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Fisher EZ Valves</strong> - Easy-e rotary control valves</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Fisher ED Valves</strong> - Easy-Drive electric actuators</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Fisher HP Valves</strong> - High performance control valves</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Fisher DVC6000 Positioners</strong> - Digital valve controllers</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Masoneilan Valves</strong> - Control and safety valves</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Valtek Control Valves</strong> - Severe service applications</span>
                  </li>
                </ul>
              </div>

              <div className="bg-gray-50 rounded-xl p-8">
                <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-radar-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">Rosemount Transmitters Oklahoma City</h3>
                <p className="text-gray-700 mb-4">
                  We buy all <strong>Rosemount transmitters in Oklahoma City Oklahoma</strong>. We purchase complete 
                  instrumentation packages from energy facilities throughout Central Oklahoma.
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Rosemount 3051 Transmitters</strong> - Pressure transmitters</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Rosemount 2088 Transmitters</strong> - Absolute pressure</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Rosemount 644 Transmitters</strong> - Temperature transmitters</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Rosemount 8800 Flowmeters</strong> - Vortex flow measurement</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Foxboro Transmitters</strong> - Process transmitters</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Fisher Transmitters</strong> - Complete transmitter line</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Safety Relief and Pipeline Valves Section */}
          <div className="mb-20">
            <h2 className="text-4xl font-bold text-slate-900 mb-6">
              Fisher Control Valve Buyers Oklahoma City Oklahoma - Fisher EZ ED HP DVC6000
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-gray-50 rounded-xl p-8">
                <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">Safety Relief Valves Oklahoma City</h3>
                <p className="text-gray-700 mb-4">
                  We purchase <strong>safety relief valves in Oklahoma City Oklahoma</strong> from refineries and 
                  energy facilities throughout Central Oklahoma.
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Crosby Relief Valves</strong> - Safety and relief valves</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Anderson Greenwood</strong> - Safety valves and regulators</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Consolidated Relief Valves</strong> - Pressure relief systems</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Leser Safety Valves</strong> - High-performance relief</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Farris Relief Valves</strong> - Industrial safety valves</span>
                  </li>
                </ul>
              </div>

              <div className="bg-gray-50 rounded-xl p-8">
                <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-git-branch-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">Pipeline Valves Oklahoma City</h3>
                <p className="text-gray-700 mb-4">
                  We buy <strong>pipeline valves in Oklahoma City Oklahoma</strong> from oil and gas pipeline 
                  operations throughout Central Oklahoma.
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Cameron Ball Valves</strong> - Pipeline ball valves</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Velan Gate Valves</strong> - High-pressure gate valves</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>WKM Gate Valves</strong> - Pipeline gate valves</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Grove Ball Valves</strong> - Trunnion mounted ball valves</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span><strong>Powell Gate Valves</strong> - Industrial gate valves</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Additional Equipment Section */}
          <div>
            <h2 className="text-4xl font-bold text-slate-900 mb-6">
              Rosemount Transmitter Buyers Oklahoma City Oklahoma - Rosemount 3051 2088 644 8800
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-gray-50 rounded-xl p-8">
                <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-tools-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">Actuators & Automation</h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>Limitorque Electric Actuators</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>Fisher Pneumatic Actuators</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>Bettis Rack & Pinion Actuators</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>Fisher Valve Positioners</span>
                  </li>
                </ul>
              </div>

              <div className="bg-gray-50 rounded-xl p-8">
                <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-settings-5-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">Controllers & Regulators</h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>Fisher Pressure Regulators</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>Foxboro DCS Controllers</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>Conoflow Precision Regulators</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>Control Air Regulators</span>
                  </li>
                </ul>
              </div>

              <div className="bg-gray-50 rounded-xl p-8">
                <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-pulse-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">Gauges & Sensors</h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>WIKA Pressure Gauges</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>RTDs and Thermocouples</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>OCI Thermowells</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>Flow Meters and Analyzers</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Safety Relief and Pipeline Valves Buyers Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-slate-900 mb-12 text-center">
            Safety Relief Valve Buyers Oklahoma City Oklahoma - Pipeline Valve Buyers
          </h2>
          
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div 
              className="rounded-3xl overflow-hidden shadow-lg bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://public.readdy.ai/ai/img_res/273beb955bd2e77c29545edd6f6ce96f.jpg')`
              }}
            >
              <div className="bg-gradient-to-t from-slate-900/80 to-transparent h-full flex items-end p-8">
                <div className="text-white">
                  <h3 className="text-2xl font-bold mb-2">Energy Capital Equipment</h3>
                  <p>Premium surplus valves from Oklahoma City's energy headquarters</p>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-3xl font-bold text-slate-900 mb-6">Oklahoma City Surplus Valve Specialists</h3>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                As <strong>Oklahoma City's leading surplus valve buyers</strong>, we serve the heart of America's 
                energy industry. With headquarters locations of Devon Energy, Chesapeake, and Continental Resources 
                nearby, we understand the specialized equipment needs and provide maximum value for your surplus 
                valve inventory from Central Oklahoma operations.
              </p>
              
              <div className="space-y-4 mb-8">
                {[
                  {
                    type: 'Energy Company Headquarters Valves',
                    description: 'Corporate facilities equipment from Devon, Chesapeake, Continental',
                    icon: 'ri-building-line'
                  },
                  {
                    type: 'Central Oklahoma Oilfield Valves',
                    description: 'Production valves from OKC area oil and gas operations',
                    icon: 'ri-oil-line'
                  },
                  {
                    type: 'Power Generation Valves',
                    description: 'OGE Energy and utility plant control valves',
                    icon: 'ri-flashlight-line'
                  },
                  {
                    type: 'Research & Development Equipment',
                    description: 'Specialty valves from energy R&D facilities and testing labs',
                    icon: 'ri-test-tube-line'
                  }
                ].map((valve, index) => (
                  <div key={index} className="flex items-start">
                    <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                      <i className={`${valve.icon} text-white text-xl`}></i>
                    </div>
                    <div>
                      <h4 className="text-slate-900 font-bold text-lg mb-2">{valve.type}</h4>
                      <p className="text-gray-700">{valve.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="bg-white rounded-lg p-6 shadow-sm">
                <h4 className="text-slate-900 font-bold mb-3">Oklahoma City Energy Advantage:</h4>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="flex items-center">
                    <i className="ri-building-line text-teal-600 mr-3"></i>
                    <span className="text-gray-700">Corporate headquarters access</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-time-line text-teal-600 mr-3"></i>
                    <span className="text-gray-700">4-6 hour response</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-money-dollar-circle-line text-teal-600 mr-3"></i>
                    <span className="text-gray-700">Energy sector expertise</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-award-line text-teal-600 mr-3"></i>
                    <span className="text-gray-700">Central Oklahoma focus</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">
              Sell Surplus Valves Oklahoma City Oklahoma - Contact Oklahoma City Oklahoma Valve Buyers
            </h2>
            <p className="text-xl text-gray-600">Common questions about selling equipment in Oklahoma City Oklahoma</p>
          </div>
          
          <div className="space-y-6">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-gray-50 rounded-2xl p-8">
                <h3 className="text-slate-900 text-xl font-bold mb-4">{faq.question}</h3>
                <p className="text-gray-700 text-lg leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-white text-4xl font-bold mb-4">Contact Oklahoma City Oklahoma Valve Buyers Today</h2>
            <p className="text-gray-300 text-xl">Fast quotes for Central Oklahoma surplus equipment</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-slate-900 text-2xl font-bold mb-6">Oklahoma City Local Office</h3>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <i className="ri-phone-line text-teal-600 text-xl mr-4"></i>
                  <div>
                    <div className="font-bold text-lg">214-854-5638</div>
                    <div className="text-gray-600">Oklahoma City Direct Line</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-mail-line text-teal-600 text-xl mr-4"></i>
                  <div>
                    <div className="font-bold">valvesalessupply@gmail.com</div>
                    <div className="text-gray-600">Equipment Lists & Photos</div>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <i className="ri-time-line text-teal-600 text-xl mr-4 mt-1"></i>
                  <div>
                    <div className="font-bold">4-6 Hour Response</div>
                    <div className="text-gray-600">Central Oklahoma Coverage</div>
                  </div>
                </div>
              </div>
              
              <div className="bg-gray-50 rounded-lg p-4">
                <h4 className="text-slate-900 font-bold mb-2">Central Oklahoma Manager</h4>
                <p className="text-gray-600">Mark Driver - Energy sector specialist</p>
              </div>
            </div>
            
            <div className="text-white">
              <h3 className="text-3xl font-bold mb-6">Oklahoma City Advantage</h3>
              <div className="space-y-4">
                {[
                  'Highest valve prices in Central Oklahoma',
                  'Fastest 4-6 hour response times',
                  'Expert energy sector experience',
                  'Complete regulatory compliance',
                  'Local OKC team with oil & gas knowledge',
                  'Oilfield equipment expertise'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-white text-xl mr-4"></i>
                    <span className="text-lg">{benefit}</span>
                  </div>
                ))}
              </div>
              
              <div className="mt-8">
                <a
                  href="tel:2148545638"
                  className="bg-white text-slate-900 px-10 py-4 rounded-full text-xl font-semibold hover:bg-gray-100 transition-all duration-300 inline-flex items-center whitespace-nowrap cursor-pointer"
                >
                  Call: (214) 854-5638
                  <i className="ri-phone-line ml-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default OklahomaCity;
